export var Config = (function () {
    const Authorization = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token') || '') : ''; 
    const access_uuid =  localStorage.getItem('access_uuid') ? JSON.parse(localStorage.getItem('access_uuid') || '') : '';  
    // REQUIRED
    // The URL to call to process FaceTec SDK Sessions.
    // In Production, you likely will handle network requests elsewhere and without the use of this variable.
    // See https://dev.facetec.com/security-best-practices?link=facetec-server-rest-endpoint-security for more information.
    // NOTE: This field is auto-populated by the FaceTec SDK Configuration Wizard.
    var DeviceKeyIdentifier = "dnTDuwQzkgM5F1IeW6AMFOLOwPWf18p7";

    //var BaseURL = "https://smb-zcs-dev.koalavsp.com";
    var BaseURL = "https://bxi-dev.csbservicios.com/n4/utils-commons/facetec"


    var AuthToken = Authorization
    var ProcessID = access_uuid
    var GeoPosition = "MX"
    var CallerIP = "10.0.0.0"

    // -------------------------------------
    // REQUIRED
    // The FaceScan Encryption Key you define for your application.
    // Please see https://dev.facetec.com/facemap-encryption-keys for more information.
    // NOTE: This field is auto-populated by the FaceTec SDK Configuration Wizard.
    var PublicFaceScanEncryptionKey = "-----BEGIN PUBLIC KEY-----"
        + "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA3irIdgBSVvXMWiVzWzSC"
        + "5zMDye1VHfInpnQaQxChfydzGW3VVnUhTVCYFnGbJqmGBmHYBN+6ssbHXE5gKg5R"
        + "lJSiRmqY+pb5EohJnWWsFOeZuMFK0QjiAQjVGQjktzcknm/KPCh95j6r7sSrwdp9"
        + "KRDf1euT32USmhUwF55TJkw2yH1RYf+5uid9p1AShYQDHuDvwKXD04L5FslI26fn"
        + "GxifxwR0pA0CGsjcdv/8u/rgpDZuFDgK1G7rn4gdVQTqnX4wzqk3FWL7MWqJh8aL"
        + "6hdZCKYcL0PanLhY2mVfRerVx1bnPGardn9nQ+G2YliM/B/A8X4kM871G34mbnF7"
        + "awIDAQAB"
        + "-----END PUBLIC KEY-----";

    /*YOUR_PRODUCTION_KEY FROM {{BaseURL}}/getInitString/web*/
    var ProductionKey = {
        "domains": "",
        "expiryDate": "2023-11-10",
        "key": "003045022100cb56ff4e9677e3325654add1be9bce0589df2873464fbbaef17a01da9833b6c502202768ed14b5ff4e1652e28b596f6e91acf5cc6f556b882c041b002e718b3898fd"
    }

    return {
        DeviceKeyIdentifier,
        BaseURL,
        PublicFaceScanEncryptionKey,
        ProductionKey,
        AuthToken,
        ProcessID,
        GeoPosition,
        CallerIP
    };

})();
